export default __webpack_public_path__ + "static/media/personal.4720de71.svg";